import { Typography, useTheme } from "@mui/material";
import { MenuItem } from "react-pro-sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { tokens } from "../theme";
import AlertDialog from "./alertDialog";
import { cloneElement, useState } from "react";
import { useRestaurant } from "../hooks/RestaurantContext";

const SideBarItem = ({ title, to, icon, isRestaurantPath = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname.startsWith(to);
  const [open, setOpen] = useState(false);
  const { setRestaurantId, setRestaurantName, setRestaurantLogo, setCurrency } =
    useRestaurant();

  const coloredIcon = icon
    ? cloneElement(icon, {
        sx: {
          ...icon.props.sx,
          color: isActive ? colors.redAccent[500] : colors.grey[100],
        },
      })
    : icon;

  const handleItemClick = (e) => {
    e.preventDefault();
    if (isRestaurantPath) {
      setOpen(true);
      return;
    }
    navigate(to);
  };

  const handleConfirm = () => {
    setOpen(false);
    navigate(to);
    setRestaurantId("");
    setRestaurantName("");
    setRestaurantLogo("");
    setCurrency("");
  };

  return (
    <>
      <MenuItem
        active={isActive}
        icon={coloredIcon}
        onClick={handleItemClick}
      >
        <Typography
          className="sidebar-item-title"
          noWrap
          sx={{ color: isActive ? colors.redAccent[500] : colors.grey[100] }}
        >
          {title}
        </Typography>
      </MenuItem>
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        title="Changer de restaurant"
        message="Souhaitez-vous vraiment changer de restaurant ?"
        deleteData={handleConfirm}
      />
    </>
  );
};

export default SideBarItem;
